import React from "react";

/* Debug
const ConversationCard = ({ user, lastMessage, onIntervene }) => (
  <div onClick={onIntervene} style={{ padding: 10, borderBottom: '1px solid #eee', cursor: 'pointer' }}>
    <strong>{user || "Unknown User"}</strong>
    <p style={{ margin: 0, color: '#666' }}>
      {lastMessage ? `${lastMessage.slice(0, 40)}...` : "No messages yet"}
    </p>
  </div>
);
*/

const ConversationCard = ({ user, lastMessage, timestamp, onIntervene }) => (
  <div 
    onClick={onIntervene} 
    style={{ 
      padding: '12px 16px',
      borderBottom: '1px solid #f0f2f5',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      backgroundColor: '#fff',
      ':hover': {
        backgroundColor: '#f5f6f6',
      }
    }}
  >
    <div style={{ 
      width: '48px', 
      height: '48px', 
      borderRadius: '50%', 
      backgroundColor: '#00a884', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      color: 'white',
      fontWeight: 'bold',
    }}>
      {user?.slice(-2)}
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <strong style={{ fontSize: '16px' }}>{user}</strong>
        <span style={{ fontSize: '12px', color: '#667781' }}>{new Date(timestamp).toLocaleTimeString()}</span>
      </div>
      <p style={{ margin: 0, color: '#667781', fontSize: '14px' }}>
        {lastMessage ? `${lastMessage.slice(0, 40)}...` : 'No messages yet'}
      </p>
    </div>
  </div>
);

export default ConversationCard;